import { useState, useEffect, useRef } from "react"

/**
 * Hook that provides an intersection observer for a given element
 * @param {number} [threshold=0.1] - The threshold for when the element is considered visible
 * @returns {Array} - An array containing the visibility state and the element reference
 */
const useIntersectionObserver = (threshold = 0.1) => {
  const [isVisible, setIsVisible] = useState(false)
  const elementRef = useRef(null)

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          setIsVisible(true)
          observer.disconnect()
        }
      },
      { threshold }
    )

    if (elementRef.current) {
      observer.observe(elementRef.current)
    }

    return () => {
      if (elementRef.current) observer.disconnect()
    }
  }, [threshold])

  return [isVisible, elementRef]
}

export default useIntersectionObserver
